<template>
  <div class="mobile-about">
    <div class="section-title">关于我们</div>
    <div class="about-content" v-html="aboutContent.content"></div>
  </div>
</template>

<script>
import { articleInfo } from '@/api/index'

export default {
  name: 'MobileAbout',
  data() {
    return {
      aboutContent: ''
    }
  },
  created() {
    this.getAboutContent()
  },
  methods: {
    getAboutContent() {
      articleInfo({ id: 6 }).then(res => {
        if (res.code === 200) {
          this.aboutContent = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-about {
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #2c9dcf;
}
.about-content {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  word-break: break-all;
}
</style>
